import React from 'react';
import { useAppSelector } from '../../store/hooks';
import Loader from './Loader';

/**
 * GlobalLoader Component
 * Displays a fullscreen loader when any API request is in loading state
 * Connect this to your Redux loading state
 */
const GlobalLoader = () => {
  // You can customize this based on your Redux state structure
  // Example: const isLoading = useAppSelector(state => state.ui.isLoading);
  // For now, we'll create a simple version that can be extended
  
  const isLoading = useAppSelector(state => {
    // Check multiple loading states from different slices
    return (
      state.ui?.loading ||
      state.auth?.loading ||
      state.flightManagement?.loading ||
      state.aircraft?.loading ||
      false
    );
  });

  return <Loader isLoading={isLoading} fullScreen={true} />;
};

export default GlobalLoader;
